export default {"src":"/_next/static/media/home.caa03405.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};